import { render, staticRenderFns } from "./towerPage.vue?vue&type=template&id=4c014af5&scoped=true&"
import script from "./towerPage.vue?vue&type=script&lang=js&"
export * from "./towerPage.vue?vue&type=script&lang=js&"
import style0 from "./towerPage.vue?vue&type=style&index=0&id=4c014af5&scoped=true&lang=css&"
import style1 from "./towerPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c014af5",
  null
  
)

export default component.exports